"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerCustomerCreateOrderInput = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const order_1 = require("../order");
exports.HaulerCustomerCreateOrderInput = typebox_1.Type.Object({
    requestedDeliveryDate: typebox_1.Type.String(),
    requestedSize: typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    }),
    requestedPickupDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    material: typebox_1.Type.String(),
    serviceLocation: order_1.ServiceLocationTransport,
    // These might be removed if they end up encoded into the `signedQuote` field. <---- This
    // rentalPeriod: DurationTransport,
    // weightLimit: WeightTransport,
    signedQuote: typebox_1.Type.String(),
    stripeToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    // stripeCustomer: Type.Optional(Type.String()), <--- this will never exist on the hauler side (for now)
    // customer info
    email: typebox_1.Type.String(),
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    phoneNumber: typebox_1.Type.String(),
    company: typebox_1.Type.Optional(typebox_1.Type.String()),
    billingAddress: typebox_1.Type.Optional(common_1.AddressTransport),
    sharedDeliveryNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sharedPickupNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    // byCheck: Type.Optional(Type.Boolean()),
    // paymentTerm: Type.Optional(Type.String()), <--- encoded in sign quote
});
// export type CustomerCreateMultipleOrdersInput = Static<typeof CustomerCreateMultipleOrdersInput>;
//# sourceMappingURL=hauler-customer-create-order.js.map